module.exports = __webpack_public_path__ + "static/media/Follower_Button-18.8cee9606.png";